<div class="signup-error-icon" aria-label="error">
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <circle cx="7" cy="7.5" r="7" fill="#D42D0E"/>
    <rect x="6" y="3.5" width="2" height="5" rx="0.5" fill="white"/>
    <rect x="6" y="9.5" width="2" height="2" rx="0.5" fill="white"/>
  </svg>
</div>
